export class UploadJapanCountryData {
    createdDate: Date;
    updatedDate: Date;
    operatingCountryIso: string;
    processingMonth: number;
    processingYear: number;
    totalCC: number;
}



// WEBPACK FOOTER //
// ./src/app/customerservice/interface/upload-japan-country-data.interface.ts